module.exports = __webpack_public_path__ + "static/media/RUMAH CERITA PNG (1).99bd91bd.png";